import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data, Router, UrlTree } from '@angular/router';

import { ActorService } from '../services';
import { Permission } from '@core/enums';

@Injectable()
export class PermissionGuard {
  constructor(
    private actor: ActorService,
    private router: Router
  ) {}

  private isAllowed(data?: Data): boolean {
    const required: Permission | undefined = data?.['permission'];
    if (!required) return true;

    const permissions: Permission[] = this.actor.get().permissions ?? [];
    return permissions.includes(required);
  }


  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.isAllowed(route.data) || this.router.createUrlTree(['/dashboard']);
  }
}
